const calcScore = (baselines, blinkRate, gazeData) => {
    /*
    baselines = [num, {x: num, y: num}]
    blinkRate = num
    gazeData = [{x: num, y: num}, ....]
    */
    let [blinkRateBase, posVarBase] = baselines;
    posVarBase = [posVarBase.x, posVarBase.y]
    // rate is per second, timeframe is per second
    const currBlinkRate = blinkRate;
    const blinkRatio = currBlinkRate / blinkRateBase; // > 1 means less attention
    
    const xData = gazeData.map(obj => obj.x);
    const yData = gazeData.map(obj => obj.y);
    const xVar = findVariance(xData);
    const yVar = findVariance(yData);

    const vars = [xVar, yVar];
    const indexOfMaxVar = argMax(vars);
    const var_ = vars[indexOfMaxVar]; // 0 or 1
    const varBase = posVarBase[indexOfMaxVar]; // 0 or 1
    const varRatio = var_ / varBase;  // > 1 means less attention

    let blinkPoints = 70;
    let gazePoints = 30;
    if (blinkRatio > 1) blinkPoints /= blinkRatio;
    if (varRatio > 1) gazePoints /= varRatio;
    // return indiv score (0, 100]
    return blinkPoints + gazePoints;
}

const findVariance = (arr = []) => {
    if(!arr.length){
       return 0;
    };
    const sum = arr.reduce((acc, val) => acc + val);
    const { length: num } = arr;
    const median = sum / num;
    let variance = 0;
    arr.forEach(num => {
       variance += ((num - median) * (num - median));
    });
    variance /= num;
    return variance;
};

const findAverage = (arr) => {
    let total = 0
    for (let elem of arr) {
        total += elem;
    }
    return total / arr.length;
}

const argMax = (array) => {
    return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
};

export { calcScore, findVariance, findAverage }